import { Zap } from 'lucide-react';

export function LoadingPage() {
  return (
    <div className="modern-loading-page">
      <div className="modern-loading-content">
        <div className="loading-icon">
          <Zap className="animate-spin" size={48} />
        </div>
        <h1 className="loading-title">ChargeQueue</h1>
        <p className="loading-subtitle">Initializing your charging experience...</p>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}